<section id="main"
         class="bg-light">
     <div id="content"
          class="container">

               <div class="overlay">
                    <h1 class="heading"
                        [innerHtml]="'Loading' | translator: 'base'"
                        [title]="'Loading' | translator: 'base'">Loading...</h1>
                    <img [alt]="'Loading' | translator: 'base'"
                         name="Loading" />
               </div>
    
     </div>
</section>